export const isButtonDisabled = (eventDetails, player) => {
    const allowedTypes = ["GRÜN", "GELB", "GELB ROT", "ROT"];
    const { type } = eventDetails;

    if (!allowedTypes.includes(type.name)) {
        return false;
    }

    const playerCards = player?.cards || [];
    if (playerCards.includes("ROT")) {
        return true;
    }

    if (type.name === "GRÜN") {
        return playerCards.length > 0;
    }

    if (type.name === "GELB") {
        if (playerCards.includes("GELB ROT")) {
            return true;
        }

        const yellowCards = playerCards.filter(
            (card) => card === "GELB"
        ).length;
        return yellowCards > 1;
    }

    if (type.name === "ROT") {
        return playerCards.includes("ROT");
    }

    if (type.name === "GELB ROT") {
        return playerCards.includes("GELB ROT");
    }

    return false;
};
